// src/hooks/usePositions.js
import { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db, auth } from '../services/firebase/config';

export const usePositions = (activePortfolio) => {
  const [positions, setPositions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPositions = async () => {
      if (!activePortfolio?.id || !auth.currentUser?.email) return;

      try {
        setIsLoading(true);
        const positionsRef = collection(db, 
          'users', 
          auth.currentUser.email,
          'portfolios',
          activePortfolio.id,
          'positions'
        );
        
        const snapshot = await getDocs(positionsRef);
        const positionsData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setPositions(positionsData);
      } catch (err) {
        console.error('Pozisyonlar yüklenirken hata:', err);
        setError('Pozisyonlar yüklenemedi');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPositions();
  }, [activePortfolio?.id]);

  const updatePosition = async (positionId, updatedData) => {
    if (!activePortfolio?.id || !auth.currentUser?.email) return;

    try {
      const positionRef = doc(db,
        'users',
        auth.currentUser.email,
        'portfolios',
        activePortfolio.id,
        'positions',
        positionId
      );

      await updateDoc(positionRef, {
        ...updatedData,
        lastUpdated: new Date()
      });

      setPositions(prevPositions => 
        prevPositions.map(pos => 
          pos.id === positionId ? { ...pos, ...updatedData } : pos
        )
      );

      return true;
    } catch (err) {
      console.error('Pozisyon güncellenirken hata:', err);
      throw new Error('Pozisyon güncellenemedi');
    }
  };

  const deletePosition = async (positionId) => {
    if (!activePortfolio?.id || !auth.currentUser?.email) return;

    try {
      const positionRef = doc(db,
        'users',
        auth.currentUser.email,
        'portfolios',
        activePortfolio.id,
        'positions',
        positionId
      );

      await deleteDoc(positionRef);

      setPositions(prevPositions => 
        prevPositions.filter(pos => pos.id !== positionId)
      );

      return true;
    } catch (err) {
      console.error('Pozisyon silinirken hata:', err);
      throw new Error('Pozisyon silinemedi');
    }
  };

  return {
    positions,
    isLoading,
    error,
    updatePosition,
    deletePosition
  };
};